
export default function About() {
  return (
    <section id="sobre" className="py-24 bg-[#FAFAFA]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/6c000be8dccd52726cab8baa6393d2b4.jpg"
              alt="Sobre a Psicóloga"
              className="w-full h-full object-cover object-top"
            />
          </div>
          
          <div>
            <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-6">
              Sobre a Psicóloga
            </h2>
            <div className="w-16 h-1 bg-[#F4C2C2] mb-8"></div>
            
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              <strong className="text-[#A8D5E2] font-medium">Simone Santos</strong> é psicóloga formada pela Universidade Padre Anchieta, com mais de 10 anos de formação. Funcionária pública na cidade de Várzea Paulista, atua com ética, empatia e responsabilidade no cuidado da saúde mental.
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Trabalha com a abordagem <strong className="font-medium">Terapia Cognitivo-Comportamental (TCC)</strong>, oferecendo um espaço seguro e acolhedor para o autoconhecimento e o desenvolvimento emocional.
            </p>
            
            <p className="text-base text-gray-700 leading-relaxed">
              Com uma prática baseada em evidências científicas, Simone auxilia seus pacientes a identificarem padrões de pensamento e comportamento, promovendo mudanças práticas e duradouras para uma vida mais equilibrada e saudável.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
